import { landingPageContents } from "../constants/content";

export default function LandingFallback({ contents = landingPageContents, websiteType = 'Kuick' }) {
  return (
    <main className="font-inter overflow-hidden">
      {/* HERO */}
      <section className="bg-white-shade-7 px-6 py-12">
        <div className="max-w-7xl mx-auto">
          <p className="text-xs font-semibold tracking-widest text-gray-500 mb-2">
            OVER 10M+ USERS
          </p>

          <h1 className="text-3xl sm:text-5xl font-semibold text-neutral-800">
            Enjoy foods all over the <span className="text-primary">world</span>
          </h1>

          <p className="mt-4 max-w-2xl text-gray-600 text-sm sm:text-base">
            {websiteType}, the most reliable food ordering app, brings the exquisite
            experience of indulging in global culinary wonders at your fingertips.
          </p>
        </div>
      </section>

      {/* STATS */}
      <section className="bg-white px-6 py-10">
        <div className="max-w-6xl mx-auto grid grid-cols-3 gap-6 text-center">
          {contents.StatsData.map((item, idx) => (
            <div key={idx}>
              <p className="text-2xl font-bold">{item.value}</p>
              <p className="text-sm text-gray-500 whitespace-pre-line">
                {item.description}
              </p>
            </div>
          ))}
        </div>
      </section>

      {/* HOW IT WORKS */}
      <section className="bg-white-shade-7 px-6 py-12">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-semibold text-center mb-10">
            How It Works
          </h2>

          <div className="grid sm:grid-cols-4 gap-8 text-center">
            {contents.ChooseOurFavFoodItems.map((item, idx) => (
              <div key={idx}>
                <p className="font-semibold">
                  {item.heading1} {item.heading2}
                </p>
                <p className="text-sm text-gray-500 mt-1">
                  {item.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* TESTIMONIAL */}
      <section className="bg-white px-6 py-12">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-2xl sm:text-3xl font-semibold mb-6">
            What Our Customers Say
          </h2>

          <p className="text-gray-600">
            {contents.Testimonials[0].contentTemplate.replaceAll(
              '{WEBSITE_TYPE}',
              websiteType
            )}
          </p>

          <p className="mt-4 font-semibold text-sm">
            — {contents.Testimonials[0].name}
          </p>
        </div>
      </section>
    </main>
  );
}
